(function() {
  "use strict";
  angular.module('app.version', [])
    .value('currentVersion', '<%= newVersion %>');
})();
